import type { FaireProductEntity } from "../../entity_types/product";

export const p_ww83v39wzf: FaireProductEntity = {
  token: "p_ww83v39wzf",
  type: "product",
  name: "Happy Dots Market Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3ff8830763adfde2ec810602ac060caa3b08f5a55e6e122aeea38509ba7691d6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c8c4b72fa7bba3d997b411b3c0a4d9061213b0e3c2a3cb8979c8e2829036f1f.png",
    "https://cdn.faire.com/fastly/83ee41f3b2d445956549af41a75a0f598d6acdf5021c204ba544ba177cebfd97.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
    "https://cdn.faire.com/fastly/2a946dcff2a8df82a8a241b9e58d049bd5f3f33901093cd34a8e59781ee13a4d.jpeg",
  ],
  priceDollars: 8,
  description:
    "Ah, the ol' kitchen list. As soon as you've gotten everything on it, it's time to start a new one. So add cheer to the chore with a cute notepad! It might even make you smile as you write down salad. Again.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:59.721Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
